import { toString } from '@pequity/shared/utils';
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useAuthStore } from '@/stores/auth';

const AI_ASSISTANT_ROUTES = ['/ranges', '/people', '/employee-portal', '/settings', '/data', '/ccpv2'];

/**
 * Composable to determine when to show the AI Assistant Widget
 */
export const useAiAssistantWidget = () => {
  const route = useRoute();
  const authStore = useAuthStore();

  const showAiAssistantWidget = computed(
    () =>
      authStore.loggedIn &&
      !!authStore.appAccess?.nav?.ai_assistant &&
      AI_ASSISTANT_ROUTES.some((path) => toString(route.path).startsWith(path))
  );

  return {
    showAiAssistantWidget,
  };
};
